
import ColorTemperatureScale from '@/components/ColorTemperatureScale.vue'

export default {
  name: 'ColorTemperatureHelp',
  components: { ColorTemperatureScale },
  props: {
    kelvin: {
      type: Number,
      default: null,
    },
    placement: {
      type: String,
      default: 'bottom',
    },
    buttonClass: {
      type: [String, Array, Object],
      default: '',
    },
    iconClass: {
      type: [String, Array, Object],
      default: 'tw-text-gray-400',
    },
  },
  methods: {
    popoverTarget() {
      const trigger = this.$refs.trigger

      return trigger?.$el || trigger
    },
  },
}
